import request from './request'

// Mock data
const mockProducts = [
  {
    id: 1,
    code: 'P001',
    name: 'iPhone 13',
    category: 'electronics',
    stock: 100,
    threshold: 20,
    remark: '苹果手机'
  },
  {
    id: 2,
    code: 'P002',
    name: 'T恤',
    category: 'clothing',
    stock: 15,
    threshold: 30,
    remark: '纯棉T恤'
  }
]

export default {
  // 获取商品列表
  getProducts: async (params) => {
    await new Promise(resolve => setTimeout(resolve, 300))
    const { keyword, category, page = 1, size = 10 } = params
    
    let filtered = [...mockProducts]
    
    if (keyword) {
      filtered = filtered.filter(item => 
        item.name.includes(keyword) || item.code.includes(keyword)
      )
    }
    
    if (category) {
      filtered = filtered.filter(item => item.category === category)
    }
    
    return {
      items: filtered.slice((page - 1) * size, page * size),
      total: filtered.length
    }
  },

  // 保存商品
  saveProduct: async (data) => {
    await new Promise(resolve => setTimeout(resolve, 300))
    if (data.id) {
      // 更新
      const index = mockProducts.findIndex(item => item.id === data.id)
      if (index > -1) {
        mockProducts[index] = { ...mockProducts[index], ...data }
      }
    } else {
      // 新增
      mockProducts.push({
        ...data,
        id: mockProducts.length + 1,
        stock: 0
      })
    }
    return { success: true }
  },

  // 获取商品详情
  getProduct: async (id) => {
    await new Promise(resolve => setTimeout(resolve, 300))
    return mockProducts.find(item => item.id === id)
  }
} 